<template>
  <g
    id="Right_Indocator"
    v-on:click="changeSeverity('frontRightIndicator')"
    :class="severityClass"
  >
    <rect class="cls-871" x="623.31" y="246.32" width="9.27" height="2.23" />
    <g>
      <circle
        class="cls-208"
        cx="620.11"
        cy="247.43"
        r="5.2"
        transform="translate(-42.44 165.03) rotate(-14.66)"
      />
      <circle
        class="cls-458"
        cx="620.11"
        cy="247.43"
        r="5.09"
        transform="translate(-42.42 164.92) rotate(-14.65)"
      />
      <circle
        class="cls-170"
        cx="620.11"
        cy="247.43"
        r="4.98"
        transform="translate(-42.41 164.77) rotate(-14.64)"
      />
      <circle
        class="cls-300"
        cx="620.11"
        cy="247.43"
        r="4.87"
        transform="translate(-42.38 164.57) rotate(-14.62)"
      />
      <circle
        class="cls-135"
        cx="620.11"
        cy="247.43"
        r="4.76"
        transform="translate(-42.35 164.3) rotate(-14.6)"
      />
      <circle
        class="cls-301"
        cx="620.11"
        cy="247.43"
        r="4.65"
        transform="translate(-42.3 163.9) rotate(-14.57)"
      />
      <circle class="cls-403" cx="620.11" cy="247.43" r="4.54" />
      <circle class="cls-363" cx="620.11" cy="247.43" r="4.43" />
      <circle class="cls-364" cx="620.11" cy="247.43" r="4.32" />
      <circle class="cls-31" cx="620.11" cy="247.43" r="4.22" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
